import { render } from "./AutomationControllerTab.vue?vue&type=template&id=4d6e9e62&scoped=true"
import script from "./AutomationControllerTab.vue?vue&type=script&lang=js"
export * from "./AutomationControllerTab.vue?vue&type=script&lang=js"

import "./AutomationControllerTab.vue?vue&type=style&index=0&id=4d6e9e62&lang=scss&scoped=true"
import "./AutomationControllerTab.vue?vue&type=style&index=1&id=4d6e9e62&scoped=true&lang=css"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6e9e62"]])

export default __exports__